module.exports = __webpack_public_path__ + "static/img/home.d6f600b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/home.svg
// module id = Q0Vg
// module chunks = 0